module.exports = "/_next/static/images/monitor-eb09133b5463cb2dc5c33924c581ef3f.svg";